import { apiClient, handleApiResponse } from './client';

export interface AllowedUsersResponse {
  emails: string[];
  total: number;
}

export interface UserAccessResponse {
  email: string;
  hasAccess: boolean;
  error?: string;
}

/**
 * Get list of allowed user emails
 */
export async function getAllowedUsers(): Promise<AllowedUsersResponse> {
  return handleApiResponse(apiClient.get('/users/allowed'));
}

/**
 * Add an email to the allowlist
 */
export async function addAllowedUser(email: string): Promise<{ message: string }> {
  return handleApiResponse(apiClient.post(`/users/allowed/${encodeURIComponent(email)}`));
}

/**
 * Remove an email from the allowlist
 */
export async function removeAllowedUser(email: string): Promise<void> {
  await apiClient.delete(`/users/allowed/${encodeURIComponent(email)}`);
}

/**
 * Check if a specific email has access
 */
export async function checkUserAccess(email: string): Promise<UserAccessResponse> {
  return handleApiResponse(apiClient.get(`/users/allowed/check/${encodeURIComponent(email)}`));
}

// Export all functions as a namespace
export const allowlistApi = {
  getAllowedUsers,
  addAllowedUser,
  removeAllowedUser,
  checkUserAccess,
};
